import gql from 'graphql-tag'

import { AppConfirmAppointementMutation } from '../../../types/api'

export default {
  mutation: gql`
    mutation AppConfirmAppointement(
      $first_name: String!
      $last_name: String!
      $email: String!
      $message: String
      $slot: ID!
    ) {
      rdvConfirmAppointment(
        first_name: $first_name
        last_name: $last_name
        email: $email
        message: $message
        slot: $slot
      ) {
        id
        first_name
        last_name
        email
        slot {
          id
          opening_hour
          closing_hour
        }
      }
    }
  `,
  transformer: (response: AppConfirmAppointementMutation) => {
    return response.rdvConfirmAppointment
  },
}
